import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-temperature-forecast-sidebar',
  templateUrl: './temperature-forecast-sidebar.component.html',
  styleUrls: ['./temperature-forecast-sidebar.component.scss']
})
export class TemperatureForecastSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  selected: string;
  queryParams: {};
  isInitialLoad: boolean = false;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];
  modalRef: any;
  sourceOptions: any = ['IMD', 'ECMWF','IMD(WRF + GFS)'];
  selectedSource: any;
  sourceMapping = {
    'IMD': 'IMD_LONG_RANGE',
    'ECMWF': 'ECMWF',
    'IMD(WRF + GFS)': 'IMD_SHORT_RANGE'
  }

  constructor(private router: Router, private route: ActivatedRoute, private gisUtils: UtilsService, private modalService: NgbModal) {
    this.selected = this.router.url.split("/")[2]
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.selectedSource = this.queryParams['source'] == 'IMD_LONG_RANGE' ? 'IMD' : this.queryParams['source'] == 'IMD_SHORT_RANGE' ? 'IMD(WRF + GFS)' : this.queryParams['source'],
        this.dateIndexLength = this.queryParams['forecastLength'] == '24' ? 9 : 7
        for (let i = 0; i < this.dateIndexLength; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
        this.requestSelectedFilterParams()
      }
    })
  }

  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'TEMPERATUREFORECAST';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  sourceChange() {
    // this.gisUtils.setHeatWaveSource.next(this.sourceMapping[this.selectedSource]);
    let options = { ...this.queryParams }
    options['source'] = this.sourceMapping[this.selectedSource]
    console.log(options['source'],"options['source']")
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });
  }

}
